import { render } from "./chart.vue?vue&type=template&id=24693336&scoped=true&ts=true"
import script from "./chart.vue?vue&type=script&lang=ts"
export * from "./chart.vue?vue&type=script&lang=ts"

import "./chart.vue?vue&type=style&index=0&id=24693336&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24693336"]])

export default __exports__